import { render, staticRenderFns } from "./navjxsy.vue?vue&type=template&id=2550d026&scoped=true&"
import script from "./navjxsy.vue?vue&type=script&lang=js&"
export * from "./navjxsy.vue?vue&type=script&lang=js&"
import style0 from "./navjxsy.vue?vue&type=style&index=0&id=2550d026&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550d026",
  null
  
)

export default component.exports